export default __webpack_public_path__ + "static/media/exeI.4ec55588.png";